module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table container-color"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container full-screen container-color"
  }, [_c('div', {
    staticClass: "text-404"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center box-text"
  }, [_c('h1', [_vm._v("YOU ARE LOST.")]), _vm._v(" "), _c('h4', [_vm._v("This page doesn't exist.")]), _vm._v(" "), _c('router-link', {
    staticClass: "link-home",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Take me home.")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09ea9382!./src/components/404/template.html
// module id = 3528
// module chunks = 1